var _path, _path2, _circle, _circle2, _path3, _path4, _path5, _ellipse, _circle3, _circle4, _rect, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStateDeliveringOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0937 46.6225C22.171 46.6225 19.5078 47.7337 17.5035 49.5567C17.3014 47.3872 17.2752 45.0639 17.2754 43.1147V42.0115H37.4407V47.2439C37.4407 49.9206 39.6106 52.0905 42.2874 52.0905C47.817 52.0905 52.2264 47.4721 51.9703 41.9484L51.4261 30.2073C51.4261 26.935 54.0591 26.0897 56.3993 29.3247C58.7087 32.5172 61.6402 40.3929 63.8405 46.7465C58.4702 47.547 54.3357 52.1316 54.2362 57.7009C48.9373 57.8344 42.38 57.8965 36.3769 57.7806C36.3095 51.6066 31.2837 46.6225 25.0937 46.6225Z",
    fill: "url(#paint0_linear_667_9888)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5445 27.9337C60.5445 30.6936 60.9323 33.1927 58.1724 33.1927C56.0686 33.1927 50.1567 29.7587 50.1567 26.9988C50.1567 24.239 52.7069 23.9844 55.4667 23.9844C58.2266 23.9844 60.5445 25.1739 60.5445 27.9337Z",
    fill: "url(#paint1_linear_667_9888)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0969,
    cy: 57.9031,
    r: 9.67943,
    fill: "url(#paint2_linear_667_9888)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.7029,
    cy: 57.8415,
    r: 9.67943,
    fill: "url(#paint3_linear_667_9888)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8799 40.9952C15.1614 39.2191 16.4685 37.2803 18.3844 37.2803H36.2805C38.6561 37.2803 39.8752 40.1258 38.2364 41.8456C37.7266 42.3808 37.0197 42.6836 36.2805 42.6836H27.707H18.3844C17.2835 42.6836 16.2928 42.0157 15.8799 40.9952Z",
    fill: "url(#paint4_linear_667_9888)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5708 25.2617L51.1288 25.9855",
    stroke: "#7CB293",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90805 32.001C7.99903 26.4921 11.5527 18.4328 21.7192 17.8926C31.7297 18.745 34.93 26.7559 34.7649 32.001H34.8645C35.6587 32.001 36.3026 32.6449 36.3026 33.4391C36.3026 34.2334 35.6587 34.8773 34.8645 34.8773H7.70672C6.91244 34.8773 6.26855 34.2334 6.26855 33.4391C6.26855 32.6449 6.91244 32.001 7.70671 32.001H7.90805Z",
    fill: "url(#paint5_linear_667_9888)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.8946,
    cy: 17.8935,
    rx: 1.94001,
    ry: 1.54972,
    fill: "#DDDEDD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.1533,
    cy: 57.959,
    r: 4,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.7031,
    cy: 57.959,
    r: 4,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7.90332,
    height: 1.8,
    rx: 0.9,
    transform: "matrix(-1 0 0 1 12.8413 47.2627)",
    fill: "url(#paint6_linear_667_9888)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5.06396,
    height: 1.8,
    rx: 0.9,
    transform: "matrix(-1 0 0 1 14.377 43.6699)",
    fill: "url(#paint7_linear_667_9888)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_667_9888",
    x1: 37.4719,
    y1: 33.9785,
    x2: 52.623,
    y2: 60.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96D4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94952,
    stopColor: "#AEEBC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_667_9888",
    x1: 55.3506,
    y1: 23.9844,
    x2: 55.3506,
    y2: 31.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99D7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5E2BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_667_9888",
    x1: 25.0969,
    y1: 48.2236,
    x2: 25.0969,
    y2: 67.5825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F9F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_667_9888",
    x1: 65.7029,
    y1: 48.1621,
    x2: 65.7029,
    y2: 67.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F9F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_667_9888",
    x1: 56.563,
    y1: 40.9014,
    x2: 16.813,
    y2: 39.9819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98D7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAE7C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_667_9888",
    x1: 21.3386,
    y1: 17.8926,
    x2: 21.3386,
    y2: 33.0458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF4EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_667_9888",
    x1: 7.59879,
    y1: 0.899996,
    x2: -0.594288,
    y2: 0.899997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAE7C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93D0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_667_9888",
    x1: 4.86884,
    y1: 0.899996,
    x2: -0.380783,
    y2: 0.899996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAE7C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93D0AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateDeliveringOn);
export default __webpack_public_path__ + "static/media/state_delivering_on.ec483b7176d89a9e5a381aec026a1593.svg";
export { ForwardRef as ReactComponent };